import {
    SOURCE_LIST_REQUEST,
    SOURCE_LIST_RESPONSE,
    SOURCE_LIST_SEARCH_REQUEST,
    SOURCE_LIST_CACHED_RESPONSE,
    SOURCE_LIST_ERROR_RESPONSE,
    SOURCE_ITEM_REQUEST,
    SOURCE_ITEM_RESPONSE,
    SOURCE_ITEM_CACHED_RESPONSE,
    SOURCE_ITEM_ERROR_RESPONSE,
    SOURCE_ITEM_SAVE_REQUEST,
    SOURCE_ITEM_SAVE_RESPONSE,
    SOURCE_ITEM_SAVE_ERROR_RESPONSE,
    SOURCE_ITEM_DELETE_REQUEST,
    SOURCE_ITEM_DELETE_RESPONSE,
    SOURCE_ITEM_DELETE_ERROR_RESPONSE,
    SOURCE_SET_FILTER,
    SOURCE_SET_EDIT_MODE,
    SOURCE_UPDATE_FILTER_CRITERIA,
    SOURCE_CLEAR_FILTER_CRITERIA,
    SOURCE_APPLY_FILTER_CRITERIA,
    SOURCE_UPDATE_IMAGE,
    SOURCE_UPDATE_MODEL,
    SOURCE_APPLY_MODEL_UPDATE,
    SOURCE_CANCEL_MODEL_UPDATE,
    SOURCE_ADD_NEW,
    SOURCE_RENDERED_LISTING_TEST_LINK,
    SOURCE_RENDERED_LISTING_CHECK_RESPONSE,
    SOURCE_RENDERED_LISTING_CHECK_ERROR_RESPONSE,
    SOURCE_RENDERED_LISTING_DISCOVER_REQUEST,
    SOURCE_RENDERED_LISTING_DISCOVER_RESPONSE,
    SOURCE_RENDERED_LISTING_DISCOVER_ERROR_RESPONSE
} from "./action-types"

import {
    itemResponse,
    itemSaveRequest,
    itemSaveErrorResponse,
    itemDeleteRequest,
    itemDeleteResponse,
    itemCachedResponse,
    itemErrorResponse,
    itemDeleteErrorResponse
} from "./default-actions/entity-actions"

import {
    itemRequest,
    setFilter,
    listSearchRequest,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    setEditMode,
    defaultAction
} from "./default-actions/presentation-actions"

import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse,
    listInvalidationRequest
} from "./default-actions/paging-actions"

// Paging Actions
export const sourceListRequest = listRequest(SOURCE_LIST_REQUEST)
export const sourceListSearchRequest = listSearchRequest(
    SOURCE_LIST_SEARCH_REQUEST
)
export const sourceListInvalidationRequest = listInvalidationRequest(
    SOURCE_LIST_REQUEST
)
export const sourceListResponse = listResponse(SOURCE_LIST_RESPONSE)
export const sourceListCachedResponse = listCachedResponse(
    SOURCE_LIST_CACHED_RESPONSE
)
export const sourceListErrorResponse = listErrorResponse(
    SOURCE_LIST_ERROR_RESPONSE
)

// Entity Actions
export const sourceItemRequest = itemRequest(SOURCE_ITEM_REQUEST)
export const sourceItemResponse = itemResponse(SOURCE_ITEM_RESPONSE)
export const sourceItemCachedResponse = itemCachedResponse(
    SOURCE_ITEM_CACHED_RESPONSE
)
export const sourceItemErrorResponse = itemErrorResponse(
    SOURCE_ITEM_ERROR_RESPONSE
)
export const sourceItemSaveRequest = itemSaveRequest(SOURCE_ITEM_SAVE_REQUEST)
export const sourceItemSaveResponse = itemResponse(SOURCE_ITEM_SAVE_RESPONSE)
export const sourceItemSaveErrorResponse = itemSaveErrorResponse(
    SOURCE_ITEM_SAVE_ERROR_RESPONSE
)
export const sourceItemDeleteRequest = itemDeleteRequest(
    SOURCE_ITEM_DELETE_REQUEST
)
export const sourceItemDeleteResponse = itemDeleteResponse(
    SOURCE_ITEM_DELETE_RESPONSE
)
export const sourceItemDeleteErrorResponse = itemDeleteErrorResponse(
    SOURCE_ITEM_DELETE_ERROR_RESPONSE
)

// Presentation Actions
export const sourceSetFilter = setFilter(SOURCE_SET_FILTER)
export const sourceSetEditMode = setEditMode(SOURCE_SET_EDIT_MODE)
export const sourceUpdateFilterCriteria = updateFilterCriteria(
    SOURCE_UPDATE_FILTER_CRITERIA
)
export const sourceClearFilterCriteria = clearFilterCriteria(
    SOURCE_CLEAR_FILTER_CRITERIA
)
export const sourceApplyFilterCriteria = applyFilterCriteria(
    SOURCE_APPLY_FILTER_CRITERIA
)
export const sourceUpdateModel = updateModel(SOURCE_UPDATE_MODEL)
export const sourceUpdateImage = updateImage(SOURCE_UPDATE_IMAGE)
export const sourceApplyModelUpdate = applyModelUpdate(
    SOURCE_APPLY_MODEL_UPDATE
)
export const sourceCancelModelUpdate = cancelModelUpdate(
    SOURCE_CANCEL_MODEL_UPDATE
)
export const sourceAddNew = defaultAction(SOURCE_ADD_NEW)
export const sourceRenderedListingTestLink = (testLink) => ({
    type: SOURCE_RENDERED_LISTING_TEST_LINK,
    testLink
})
export const sourceRenderedListingCheckResponse = (check) => ({
    type: SOURCE_RENDERED_LISTING_CHECK_RESPONSE,
    check
})
export const sourceRenderedListingCheckErrorResponse = (error) => ({
    type: SOURCE_RENDERED_LISTING_CHECK_ERROR_RESPONSE,
    error
})
export const sourceRenderedListingDiscoverRequest = (url) => ({
    type: SOURCE_RENDERED_LISTING_DISCOVER_REQUEST,
    url
})
// Both carry the URL that was looked at, so a look that finishes after the source or its URL changed is ignored
export const sourceRenderedListingDiscoverResponse = (discover, url) => ({
    type: SOURCE_RENDERED_LISTING_DISCOVER_RESPONSE,
    discover,
    url
})
export const sourceRenderedListingDiscoverErrorResponse = (error, url) => ({
    type: SOURCE_RENDERED_LISTING_DISCOVER_ERROR_RESPONSE,
    error,
    url
})
